// src/components/landing/About.jsx
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-20 bg-[#0B0C0D]">
      <div className="container mx-auto px-4">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl font-bold text-white mb-4">About WriteApp</h2>
          <p className="text-gray-400 max-w-3xl mx-auto">
            Your handwriting is more than just communication—it's a deeply personal expression of your subconscious mind, emotional wiring, and unique personality.
          </p>
        </motion.div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            <h3 className="text-2xl font-semibold text-white mb-4">Real Human Expertise</h3>
            <p className="text-gray-400 mb-4">
              WriteApp.in is not just another personality quiz or automated result generator. Here, real human experts decode your handwriting sample using advanced principles of graphology and behavioral psychology.
            </p>
            <p className="text-gray-400 mb-4">
              Every curve, pressure, space, and slant in your handwriting carries subtle yet powerful clues about your thoughts, behaviors, fears, strengths, and decision-making patterns.
            </p>
            <p className="text-gray-400">
              Our platform is designed for curious individuals ready to dive into the world of self-awareness, emotional patterns, and personality decoding—all completely free and accessible.
            </p>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="bg-dark-gray/30 backdrop-blur-sm border border-gray-800 p-8 rounded-xl hover:shadow-lg hover:border-gray-700 transition-all duration-500"
            whileHover={{ y: -10, transition: { duration: 0.3, ease: "easeOut" } }}
          >
            <h3 className="text-2xl font-semibold text-white mb-4">What Sets Us Apart</h3>
            <ul className="space-y-4">
              <motion.li 
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="flex items-start"
              >
                <div className="bg-primary/20 p-2 rounded-full mr-3 mt-1">
                  <svg className="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-gray-400"><span className="text-white">Transparency:</span> We show you exactly how we know—every analysis explains the handwriting formations behind our conclusions.</p>
              </motion.li>
              <motion.li 
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="flex items-start"
              >
                <div className="bg-primary/20 p-2 rounded-full mr-3 mt-1">
                  <svg className="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-gray-400"><span className="text-white">Deep Analysis:</span> From letter size and pressure to spacing and zones—we analyze everything to understand your personality traits.</p>
              </motion.li>
              <motion.li 
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="flex items-start"
              >
                <div className="bg-primary/20 p-2 rounded-full mr-3 mt-1">
                  <svg className="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-gray-400"><span className="text-white">Personal Growth:</span> Explore traits like perfectionism, empathy, analytical thinking, and emotional patterns for self-development.</p>
              </motion.li>
              <motion.li 
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.6 }}
                className="flex items-start"
              >
                <div className="bg-primary/20 p-2 rounded-full mr-3 mt-1">
                  <svg className="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-gray-400"><span className="text-white">Safe & Confidential:</span> A respectful experience where your hidden traits are revealed with kindness and psychological precision.</p>
              </motion.li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;